module.exports = __webpack_public_path__ + "img/new_20231205_02.c4200266.png";